module.exports = __webpack_public_path__ + "img/warning.ee95f1cc.svg";